var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"web-container",attrs:{"id":"app"}},[_c('router-view'),_c('notifier'),_c('push-popup'),_c('portal-target',{attrs:{"name":"easy-bottom","transition":"fade-transition"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }